export default "<!--component html goes here -->\r\n";